import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import './fileUpload.css';

/*
#tailwind
*/

function FileUpload({ onChange, accept, name, disabled, multiple, children, className, ...other }) {
  const fileInput = useRef(null);

  const onClick = useCallback(() => {
    fileInput.current.click();
  }, []);

  const onFileChange = useCallback(
    async (event) => {
      await onChange?.(event);
      if (fileInput.current) {
        fileInput.current.value = null;
      }
    },
    [onChange]
  );

  return (
    <div className={className} {...other}>
      <input
        type="file"
        className="fileUpload__fileInput"
        onChange={onFileChange}
        accept={accept}
        name={name}
        disabled={disabled}
        multiple={multiple}
        ref={fileInput}
        {...other}
      />
      <span onClick={onClick}>{children}</span>
    </div>
  );
}

FileUpload.propTypes = {
  onChange: PropTypes.func,
  accept: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

FileUpload.defaultProps = {
  onChange: undefined,
  accept: undefined,
  name: undefined,
  disabled: false,
  multiple: false,
  children: undefined,
  className: undefined,
};

export default FileUpload;
